<template>
  <div>
    <router-view />
  </div>
</template>

<script>

  export default {
    name: 'App',
  }
</script>

<style>
* {
  font-family: 'Inter', sans-serif !important;
}

/* Restaurar fontes de ícones - deve vir DEPOIS da regra universal */
i.fas, span.fas,
i.fa, span.fa {
  font-family: "Font Awesome 6 Free" !important;
  font-weight: 900 !important;
}

.pi {
  font-family: "primeicons" !important;
}

:root {
  --app-accent: #2563eb;
  --app-accent-hover: #1d4ed8;
  --app-sidebar-bg: #0f172a;
  --app-sidebar-fg: #cbd5f5;
  --app-bg: #f3f4f8;
}

.thin-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.thin-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
}

.v-application .v-main {
  background-color: var(--app-bg);
}

.brand-gradient-bg {
  background: linear-gradient(135deg, #22d3ee, var(--app-accent) 55%, #a855f7);
}


.v-application {
  font-family: 'Inter', sans-serif !important;
}

.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .headline,
.v-application .title,
.v-application .subtitle-1,
.v-application .subtitle-2,
.v-application .body-1,
.v-application .body-2,
.v-application .caption,
.v-application .overline {
  font-family: 'Inter', sans-serif !important;
}
</style>
